var exports = {
  "jy": "AnimationTab.module__radioSection___RE43ZW",
  "lm": "AnimationTab.module__radioHeader___RE43ZW",
  "et": "AnimationTab.module__radioLabel___RE43ZW",
  "Ye": "AnimationTab.module__radioDescription___RE43ZW",
  "X0": "AnimationTab.module__reducedMotionNote___RE43ZW",
};

module.exports = exports;
